import { GtmTrackingType } from '../constants';

class GtmCheckoutViewDelegator {
	constructor() {
		this.type = GtmTrackingType.CHECKOUT_VIEW;
	}

	getTrackingData() {
		const { checkoutStepNumber } = window.dataLayer[0].navigation;

		if (checkoutStepNumber) {
			const trackingObj = {
				event: 'checkoutView',
				ecommerce: {
					checkout: {
						actionField: {
							step: checkoutStepNumber,
						},
						products: this.mapProductData(),
					},
				},
			};

			if (window.dataLayer[0]?.order?.paymentType) {
				trackingObj.ecommerce.checkout.actionField.option =
					window.dataLayer[0].order.paymentType;
			}

			return trackingObj;
		}
	}

	mapProductData() {
		const { products } = window.dataLayer[0].basket;
		if (products) {
			return products.map(product => {
				return {
					name: product.skuTitle,
					id: product.skuID,
					price: product.skuPriceexVAT,
					quantity: product.skuQty,
					category: product.skuHierarchy,
					item_category: product.skuItemCategory,
					item_category2: product.skuItemCategory2,
					item_category3: product.skuItemCategory3,
					dimension19: product.pricingType,
				};
			});
		}

		return [];
	}
}

const GtmCheckoutViewDelegatorInstance = new GtmCheckoutViewDelegator();
export default GtmCheckoutViewDelegatorInstance;

// for test purpose only
export const GtmCheckoutViewDelegatorClass = GtmCheckoutViewDelegator;
